import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Box, Divider, Grid, Paper, Tab, Typography } from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { getUserInfo } from "../../../../utilities/storage";
import {
  getCasesRequest,
  getClosedCasesRequest,
  getOpenCasesRequest,
} from "../../CasesApiAction";
import { useStyles } from "./styles";
import CaseList from "./components/CaseItem/CaseList";

/**
 * function to render case form
 * @param selectedDept: selected department
 * @param getCases: function to get cases
 * @param cases: cases list
 * @param getOpenCases: function to get open cases
 * @param openCases: open cases list
 * @param getClosedCases: function to get closed cases
 * @param closedCases: closed cases list
 * @returns {JSX.Element}
 * @constructor
 */
const Cases = ({
  selectedDept,
  getCases,
  cases,
  getOpenCases,
  openCases,
  getClosedCases,
  closedCases,
}) => {
  const classes = useStyles();
  const role = getUserInfo().Roles[0].name;
  const [loadingOpen, setLoadingOpen] = React.useState(false);
  const [loadingClosed, setLoadingClosed] = React.useState(false);
  const [loadingAll, setLoadingAll] = React.useState(false);

  const [value, setValue] = React.useState("1");

  const fetchOpenCases = () => {
    setLoadingOpen(true);
    getOpenCases(selectedDept?.team_id).finally(() => setLoadingOpen(false));
  };

  const fetchClosedCases = () => {
    setLoadingClosed(true);
    getClosedCases(selectedDept?.team_id).finally(() =>
      setLoadingClosed(false)
    );
  };

  const fetchAllCases = () => {
    if (selectedDept?.headDoctor) {
      setLoadingAll(true);
      getCases().finally(() => setLoadingAll(false));
    }
  };

  /**
   * function to handle tab change
   * @param e: event from button click
   * @param newValue: tab value
   */
  const handleChange = (event, newValue) => {
    setValue(newValue);

    if (newValue === "1") {
      fetchOpenCases();
    } else if (newValue === "2") {
      fetchClosedCases();
    } else if (newValue === "3") {
      fetchAllCases();
    }
  };

  useEffect(() => {
    fetchOpenCases();
  }, [selectedDept?.team_id]);

  return (
    <Box className={classes.outerContainer}>
      <Box className={classes.casesContainer}>
        <TabContext value={value}>
          <Box className={classes.headerContainer}>
            <TabList
              component={Paper}
              indicatorColor="primary"
              textColor="primary"
              value={value}
              onChange={handleChange}
              className={classes.tabsContainer}
            >
              <Tab
                label={`Open (${openCases.count ? openCases.count : "0"})`}
                value="1"
              />
              <Tab
                label={`Closed (${
                  closedCases.count ? closedCases.count : "0"
                })`}
                value="2"
              />

              {selectedDept?.headDoctor === true ? (
                <Tab
                  label={`All (${cases.count ? cases.count : "0"})`}
                  value="3"
                />
              ) : (
                <></>
              )}
            </TabList>

            <Divider />
          </Box>

          <Box>
            <TabPanel value="1">
              <CaseList
                loading={loadingOpen}
                data={openCases}
                classes={classes}
              />
            </TabPanel>

            <TabPanel value="2">
              <CaseList
                loading={loadingClosed}
                data={closedCases}
                classes={classes}
              />
            </TabPanel>

            <TabPanel value="3">
              <CaseList loading={loadingAll} data={cases} classes={classes} />
            </TabPanel>
          </Box>
        </TabContext>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedDept: state.ayucareUsers.selectedDept,
    cases: state.cases.cases,
    openCases: state.cases.openCases,
    closedCases: state.cases.closedCases,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCases: () => {
      return dispatch(getCasesRequest()).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getOpenCases: (id) => {
      return dispatch(getOpenCasesRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getClosedCases: (id) => {
      return dispatch(getClosedCasesRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cases);
